import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoDmComponent } from './video-dm.component';
import { YouTubePlayerModule } from '@angular/youtube-player';



@NgModule({
  declarations: [
    VideoDmComponent
  ],
  imports: [
    CommonModule,
    YouTubePlayerModule

  ],
  exports: [VideoDmComponent]
})
export class VideoDmModule {
  getComponent() {
    return VideoDmComponent;
  }
}
